import './Organization.scss';
import React, { useState, useEffect, useContext, useReducer } from 'react';
import { Spin } from 'antd';
import useGetOrganizationsData from 'app/hooks/useGetOrganizationsData';
import { Select, Space } from 'antd';
import { CaretDownFilled, ShopFilled } from '@ant-design/icons';
import { OrganizationsContext } from 'app/store/OrganizationContext';
import { StyleProvider } from '@ant-design/cssinjs';

const OrganizationList = () => {
  const [organizations, setOrganizations] = useState([]);
  const { responseData, isLoading, error } = useGetOrganizationsData();
  const { updateSelectedOrganizationId } = useContext(OrganizationsContext);

  useEffect(() => {
    if (responseData) {
      setOrganizations(responseData);
      updateSelectedOrganizationId(responseData[0].organizationId);
    }
  }, [responseData]);

  const handleOrganizationChange = (value: string) => {
    updateSelectedOrganizationId(value);
  };

  return (
    <div className="organization-wrapper">
      {isLoading ? (
        <div className="loading-section">
          <Spin tip="loading..." />
        </div>
      ) : (
        <>
          {organizations && organizations.length > 0 && (
            <StyleProvider hashPriority="high">
              <Space wrap>
                <ShopFilled className="organization-icon" />
                <Select
                  defaultValue={organizations[0].organizationName}
                  style={{ width: 132 }}
                  onChange={handleOrganizationChange}
                  suffixIcon={<CaretDownFilled />}
                  options={organizations.map(item => ({ label: item.organizationName, value: item.organizationId }))}
                />
              </Space>
            </StyleProvider>
          )}
        </>
      )}
    </div>
  );
};

export default OrganizationList;
